import config from '../_config/config';
import { authHeader } from '../_helpers';
//console.log( config );
export const orderService = {
    saveNew,
    getAll
};

function saveNew( deliverydate, basket ) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: JSON.stringify({ deliverydate, basket })
        };


    return fetch(`${config.apiUrl}/orders/savenew/`, requestOptions)
        .then(handleResponse)
        .then(res => {
          if( res.success ) {
            return res;
          }
        });

}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/orders/`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}